import React, { memo, forwardRef } from "react";
const SvgGreaterthanorequalto = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M9.447 6.106a1 1 0 00-.895 1.789L20.763 14l-12.21 6.106a1 1 0 00.894 1.789l14-7a1 1 0 000-1.79l-14-7zM8.999 23a1 1 0 100 2h14a1 1 0 100-2H9z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgGreaterthanorequalto.displayName = "SvgGreaterthanorequalto";
const MemoForwardRef = memo(SvgGreaterthanorequalto);
export default MemoForwardRef;
